import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import Raven from 'raven-js';
import { Component } from 'react';

// Define the props for the HOC

// Define the state for the ErrorBoundary component
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @deprecated Use the new withErrorBoundary component from ai-components-ui-library instead.
 * This legacy component is maintained for backward compatibility.
 */ // HOC to wrap a component with error boundary functionality
const LEGACY_withErrorBoundary = WrappedComponent => {
  return class ErrorBoundary extends Component {
    constructor(props) {
      super(props);
      this.state = {
        hasError: false
      };
    }
    static getDerivedStateFromError() {
      // Update state so the next render will show the fallback UI
      return {
        hasError: true
      };
    }
    componentDidCatch(error) {
      // You can log the error to an error reporting service here
      Raven.captureException(new Error('[Copilot Preview ErrorBoundary]', error));
    }
    render() {
      if (this.state.hasError) {
        // Render fallback UI if error is caught
        return /*#__PURE__*/_jsx(UIErrorMessage, {
          type: "badRequest",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "aiAddonCopilotPreview.components.copilotPreview.error.title"
          }),
          children: /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "aiAddonCopilotPreview.components.copilotPreview.error.message"
            })
          })
        });
      }

      // Render the wrapped component with all its props
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props));
    }
  };
};
export default LEGACY_withErrorBoundary;